var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyebrows = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.929 40.769c-.087-.335-.32-.6-.63-.72-7.142-2.75-31.377-7.035-31.377-7.035a.986.986 0 0 0-.546.061l-23.737 9.917c-.49.207-.748.77-.595 1.302.157.526.674.845 1.19.725 0 0 19.75-4.58 23.406-4.16 3.688.422 33.065 9.101 33.065 9.101a.99.99 0 0 0 .991-.266c.26-.27.364-.664.27-1.033l-2.034-7.892h-.003Zm-1.826 1.089 1.432 5.552c-6.386-1.87-28.49-8.299-31.671-8.665-1.828-.21-7.583.78-13.005 1.849l13.005-5.435c2.64.472 23.124 4.16 30.237 6.7l.002-.001Z",
    fill: "currentColor"
  }))));
};
export { SvgEyebrows as ReactComponent };